import AntSwitch  from "_components/atoms/antSwitch";
import Typography from "_components/atoms/typography";
import Icon       from "_components/atoms/icon";
import useStyles  from "./styles";

const component = ( {
	enabledState,
	// toggleEnableState,
	settingsName,
	title,
	updateNotificationStates
} ) => {
	return (
		<SettingsOption
			enabledState      = { enabledState }
			settingsName          = { settingsName }
			title             = { title }
			updateNotificationStates = { updateNotificationStates }
		/>
	);
};

export default component;

const SettingsOption = ( {
	title,
	settingsName,
	enabledState = 0,
	// toggleEnableState
	updateNotificationStates
} ) => {

	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<div className = { classes.optionContainer }>
			<div className = { classes.flexContainer }>
				<div style = { { display: "flex", alignItems: "center" } }>
					<CustomOptionIcon iconName = { settingsName } />

					<Typography
						className = { `${ classes.optionText } fontBold leftSpacing` }
						title = { title }
					/>
				</div>

				<div>
					<AntSwitch
						checked  = { enabledState }
						onChange = { () => updateNotificationStates ( settingsName, enabledState ) }
					/>
				</div>
			</div>
		</div>
	);
};

export const CustomOptionIcon = ( { iconName } ) => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	switch ( iconName ) {
		case "subscribed":
			return (
				<Icon
					sameInBothTheme
					className = { classes.avatar }
					name = "subscribed"
				/>
			);

		case "recommendations":
			return (
				<Icon
					sameInBothTheme
					className = { classes.avatar }
					name = "notifRecommended"
				/>
			);

		case "new_followers":
			return (
				<Icon
					sameInBothTheme
					className = { classes.avatar }
					name = "newFollowers"
				/>
			);

		case "comments_on_your_post":
			return (
				<Icon
					sameInBothTheme
					className = { classes.avatar }
					name = "newComments"
				/>
			);

		case "likes_on_your_post":
			return (
				<Icon
					sameInBothTheme
					className = { classes.avatar }
					name = "notifLikes"
				/>
			);

		case "shares_on_your_post":
			return (
				<Icon
					sameInBothTheme
					className = { classes.avatar }
					name = "notifShares"
				/>
			);

		case "stream_summary":
			return (
				<Icon
					sameInBothTheme
					className = { classes.avatar }
					name = "notifStreamSummary"
				/>
			);

		case "daily_growth_reports":
			return (
				<Icon
					sameInBothTheme
					className = { classes.avatar }
					name = "notifStreamSummary" // uses same icon as stream summary.
				/>
			);

		case "achievements":
			return (
				<Icon
					sameInBothTheme
					className = { classes.avatar }
					name = "notifAchievements"
				/>
			);

		case "alerts":
			return (
				<Icon
					sameInBothTheme
					className = { classes.avatar }
					name = "notifAlerts"
				/>
			);

		case "coins_added":
			return (
				<Icon
					sameInBothTheme
					className = { classes.avatar }
					name = "notifCoins"
				/>
			);

		case "diamonds_added":
			return (
				<Icon
					sameInBothTheme
					className = { classes.avatar }
					name = "notifDiamonds"
				/>
			);

		default:
			return null;
	}
};